import React from 'react';
import { LeftMenuView } from '../../../components/menu/LeftMenuView';
import { UnthinkablePages } from './UnthinkablePages';
import { BlogsForm } from './BlogsForm';
import { BlogsTable } from './BlogsTable';

export const WebsiteMenu = props => {
    const { route: { params } = {} } = props;

    const menus = [
        {
            label: 'Pages',
            view: <UnthinkablePages {...props} />,
        },
        {
            label: 'Blogs',
            view: <BlogsTable {...props} />,
        },
    ];

    return <LeftMenuView {...props} params={params} menus={menus} />;
};